import gql from 'graphql-tag'

const parseBigintArray = value => {
	if (Array.isArray(value)) return value
	if (!value || typeof value !== 'string') return []
	return value
		.replace(/[{}]/g, '')
		.split(',')
		.map(item => item.trim())
		.filter(Boolean)
}

export const queryContractTemplateByPk = id => {
	return {
		query: gql`
			query($id: bigint!) {
				pdf_templates_by_pk(id: $id) {
					name
					organization_id
					country
					comercial_base
					contract_type
					comercial_category_id
					contract_categories
					template_url
				}
			}
		`,
		update(data) {
			return {
				name: data.pdf_templates_by_pk.name,
				organizationId: data.pdf_templates_by_pk.organization_id,
				country: data.pdf_templates_by_pk.country,
				comercialBase: data.pdf_templates_by_pk.comercial_base,
				contractType: data.pdf_templates_by_pk.contract_type,
				comercialCategoryId: data.pdf_templates_by_pk.comercial_category_id,
				contractCategories: parseBigintArray(data.pdf_templates_by_pk.contract_categories),
				templateUrl: data.pdf_templates_by_pk.template_url
			}
		},
		variables: {
			id: parseInt(id)
		}
	}
}
